"use client";

import Image from "next/image";

import { IntersectWrapper } from "@/components/intersect-wrapper";
import { CategoryItemData } from "@/features/media-center/services/get-category-data";

export const MediaCardImage = (data: CategoryItemData) => (
  <IntersectWrapper className="relative h-full w-full">
    <Image
      fill
      priority
      placeholder="blur"
      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPk8cr7DwAC8wHF8e4zAAAAAABJRU5ErkJggg=="
      src={data.coverPicture}
      alt={data.title}
      className="transition-all group-hover/container:scale-[105%]"
      sizes="(min-width: 1024px) 530px, (min-width: 768px) 320px, 100vw"
    />
  </IntersectWrapper>
);
